module.exports = __webpack_public_path__ + "img/econutri.f76b9590.png";